module.exports = __webpack_public_path__ + "static/travlr.b4aeb7eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/travlr.jpg
// module id = 439
// module chunks = 35783957827783